import React from 'react';
import { Topic, QuizQuestion } from '../types';

interface QuizViewProps {
  selectedTopic: Topic | null;
  quizQuestions: QuizQuestion[];
  answers: number[];
  setAnswers: (answers: number[]) => void;
  submitQuiz: () => void;
  loading: boolean;
  setCurrentView: (view: 'lesson') => void;
}

export const QuizView: React.FC<QuizViewProps> = ({
  selectedTopic,
  quizQuestions,
  answers,
  setAnswers,
  submitQuiz,
  loading,
  setCurrentView
}) => {
  if (!selectedTopic) return null;

  return (
    <div>
      <button
        onClick={() => setCurrentView('lesson')}
        style={{ background: 'none', border: 'none', color: '#22c55e', fontSize: '14px', cursor: 'pointer', marginBottom: '20px' }}
      >
        ← Back to Lesson
      </button>
      
      <h2 style={{ marginBottom: '8px' }}>Quiz: {selectedTopic.title}</h2>
      <p style={{ color: '#6b7280', marginBottom: '24px' }}>Answer all questions to test your knowledge</p>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {quizQuestions.map((q, idx) => (
          <div key={q.id} style={{ background: 'white', borderRadius: '16px', padding: '20px', border: '1px solid #e5e7eb' }}>
            <div style={{ fontSize: '12px', color: '#22c55e', fontWeight: '600', marginBottom: '12px' }}>Question {idx + 1}</div>
            <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '20px' }}>{q.question}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {q.options.map((opt, optIdx) => (
                <label key={optIdx} style={{ display: 'flex', alignItems: 'center', padding: '12px', background: '#f9fafb', borderRadius: '12px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name={`q${idx}`}
                    value={optIdx}
                    checked={answers[idx] === optIdx}
                    onChange={() => {
                      const newAnswers = [...answers];
                      newAnswers[idx] = optIdx;
                      setAnswers(newAnswers);
                    }}
                    style={{ marginRight: '12px' }}
                  />
                  <span style={{ fontWeight: 'bold', marginRight: '12px' }}>{String.fromCharCode(65 + optIdx)}.</span>
                  <span>{opt}</span>
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
      
      <button
        onClick={submitQuiz}
        disabled={loading}
        style={{ width: '100%', padding: '16px', marginTop: '24px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '12px', fontWeight: '600', fontSize: '16px', cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}
      >
        {loading ? 'Submitting...' : 'Submit Answers'}
      </button>
    </div>
  );
};
